<template>
  <v-row>
    <span v-if="itemData.isExtra">
      <v-icon color="yellow darken-2" left>mdi-star</v-icon
      >{{ itemData.boardBasis }} ({{ itemData.serviceName }})
    </span>
    <span v-else>{{ itemData.serviceName }}</span>
  </v-row>
</template>

<script>
export default {
  name: "serviceName-label",

  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    itemData() {
      return this.params ? { ...this.params.data } : { ...this.item };
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/labels/ServiceNameLabel.vue